import { useState } from 'react';

import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';

import API from '../../../../../libs/api';
import { selectWebsiteId } from '../../../../../selectors/website';
import useAsyncEffect from '../../../foundation/hooks/use-async-effect';
import {
  selectAllStyleRuleConfigurations,
  setAllStyleRuleConfigurations,
} from '../../slices/StyleRuleConfiguration.slice';

export default function useStyleRuleConfigurations({ forceFetch = false } = {}) {
  const websiteId = useSelector(selectWebsiteId);
  const styleRuleConfigurations = useSelector(selectAllStyleRuleConfigurations);

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  async function fetchStyleRuleConfigurations() {
    try {
      setLoading(true);
      const { data } = await API.getStyleRulesConfiguration(websiteId);
      dispatch(setAllStyleRuleConfigurations(data));
    } finally {
      setLoading(false);
    }
  }

  useAsyncEffect(async () => {
    if (_isEmpty(styleRuleConfigurations) || forceFetch) {
      await fetchStyleRuleConfigurations();
    }
    setLoading(false);
  }, []);

  return { styleRuleConfigurations, loading };
}
